/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
          // JavaScript to be fired on all pages

          var slugs = $('.brand-filters-wrap select'),
              brands = $('.brands-wrapper .brand');

          // selectric
          $('.brand-filters-wrap select').selectric().on('change', function () {
              // console.log($(this).val());
              var slug = $(this).val(),
                  class_selector = '';

              // build our filter
              $(slugs).each(function () {
                  if ($(this).val() !== '') {
                      class_selector += '.' + $(this).val();
                  }
              });

              // apply our filter
              if (class_selector !== '') {
                  $(brands).hide().filter(class_selector).show();
              } else {
                  $(brands).show();
              }

          });
          /****** PRIVACY LINK TRANSLATION ******/
          /* Since the link for the privacy page can be set only in one language, we manually fix it when we are
          on other languages adding the strip that comes from the body and add it in the link.
           */
          var lang = $("html").attr("lang"),
            cookieBar = $("#cookie-law-info-bar"),
            readMoreBtn = cookieBar.find(".cli-plugin-main-link"),
            readMoreLink = readMoreBtn.attr("href");
          if(lang){
              switch($("html").attr("lang")){
                  case "es-ES":
                      readMoreLink = "/es" + readMoreLink;
                      break;
                  case "nl-NL":
                      readMoreLink = "/nl" + readMoreLink;
                      break;
                  case "fr-FR":
                      readMoreLink = "/fr" + readMoreLink;
                      break;
                  case "de-DE":
                      readMoreLink = "/de" + readMoreLink;
                      break;
                  default:
                      break;
              }
              readMoreBtn.attr("href", readMoreLink);
          }


          /****** FOOTER ******/
          // var footerPhoneNumber = $("");
          $("<option value='none'>None of these</option>")
              .insertAfter($('.frm_form_fields select').children("option").eq(0));

          if (countries) {
              for(var country in countries){
                  if(countries[country]["appears_in_forms"]){
                      $('.frm_form_fields select').append("<option value='" + country + "'>" + countries[country]['country_name'] + "</option>");
                      console.log(country);
                  }
              }
          }

          if (countriesExcluded) {
              countriesExcluded.forEach(function (elem, index) {
                  if (elem.country_name) {
                      var optionToRemove = $("footer").find("option[value='" + elem.country_name + "']");
                      if (optionToRemove.length > 0) {
                          optionToRemove.remove();
                      }
                  }
              });
          }

          var formSubtitle = $("#footer_form_lbl .subtitle"),
              formSubtitleInitialVal = formSubtitle.html(),
              formPhone = $("#footer_form_lbl .phone_number"),
              formPhoneInitialVal = formPhone.html(),
              exportPlaceholder = $("#export-value-placeholder"),
              exportSubtitle = exportPlaceholder.data("exportParagraph"),
              exportPhone = exportPlaceholder.data("exportPhone");

          //this is used for the OPCO Pages, if in the footer the option for preselection is active
          //we modify the selected country, this is especially useful since the user can hide the select box where needed
          if($("#preselected-country").length > 0 && $("#preselected-country").data("preselected")){
              $('.frm_form_fields select').val($("#preselected-country").data("preselected"));
          }

          /*
           if country phones exists, we add an option for "none" and "UCC Europe Head Office",
           so that the footer can change correctly
           */
          var callUs = [],
              countryFallback = [];
          switch($("html").attr("lang")){
              case "es-ES":
                  callUs = ["Llame a "," o complete sus datos a continuación "];
                  countryFallback = ["Llame a nuestra oficina en "," o complete sus datos a continuación"];
                  break;
              case "nl-NL":
                  callUs = ["Bel "," of vul uw gegevens in"];
                  countryFallback = ["Bel ons kantoor in "," of vul uw gegevens in"];
                  break;
              case "fr-FR":
                  callUs = ["Contactez "," ou remplissez les champs ci-dessous"];
                  countryFallback = ["Contactez notre bureau en "," ou remplissez les champs ci-dessous"];
                  break;
              case "de-DE":
                  callUs = ["Rufen Sie uns an "," oder füllen Sie weiter unten das Kontaktformular aus"];
                  countryFallback = ["Wenden Sie sich bitte an unser Büro in "," oder füllen Sie weiter unten das Kontaktformular aus"];
                  break;
              default:
                  callUs = ["Call "," or fill in your details below"];
                  countryFallback = ["Call our office in "," or fill in your details below"];
                  break;
          }

          /*
          We add a country value for the ucc head office so that the right string can be composed when selected
          This is necessary as in the export page, the normal behaviour of falling back to the initial string is not correct.
          The initial string on that page is the export, therefore clicking on the UCC Europe Head Office reports to the export info, this behaviour is incorrect.
         */
          if(country_phones){
              country_phones["UCC Europe Head Office"] = {
                  "email" : "cygjacktest2@gmail.com",
                  "name" : "London",
                  "office_name" : "UCC Europe Head Office",
                  "telephone" : "+44 (0) 20 8799 4370"
              };

              switch($("html").attr("lang")){
                  case "es-ES":
                      country_phones["UCC Europe Head Office"]["custom_call_us_blurb"] = "Llame a nuestra oficina central europea en Londres en el teléfono o incluya sus datos a continuación*";
                      break;
                  case "nl-NL":
                      country_phones["UCC Europe Head Office"]["custom_call_us_blurb"] = "Bel ons Europese hoofdkantoor in Londen of vul uw gegevens hieronder in*";
                      break;
                  case "fr-FR":
                      country_phones["UCC Europe Head Office"]["custom_call_us_blurb"] = "Appelez notre siège européen à Londres ou remplissez le formulaire ci-dessous*";
                      break;
                  case "de-DE":
                      country_phones["UCC Europe Head Office"]["custom_call_us_blurb"] = "Rufen Sie unsere Europa-Zentrale in London oder tragen Sie Ihre Kontaktdaten unten ein*";
                      break;
                  default:
                      country_phones["UCC Europe Head Office"]["custom_call_us_blurb"] = "Call our European Head Office in London or fill in your details below*";
                      break;
              }
          }


          $('.frm_form_fields select').selectric({
              onBeforeInit: function () {
                  $('.frm_form_fields select').children("option").first().val("");
              }
          })
              .on("change", function () {
                  var value = $(this).val();

                  //if the country selected has a footer sync, an office name and a phone number we change the subtitle and phone accordingly
                  if (country_phones && country_phones.hasOwnProperty(value)) {

                      //we double check we have everything
                      if (country_phones[value]['telephone'] && country_phones[value]['name']) {
                          formSubtitle.slideUp();
                          formPhone.slideUp(function () {

                              //a country might have a full blurb that it might be used to overwrite completely the normal structure
                              //made out by office name + phone number
                              if(country_phones[value]['custom_call_us_blurb']){
                                  formSubtitle.html(country_phones[value]['custom_call_us_blurb']);
                              }else{

                                  //if no blurb provided we change the copy with the normal structure,
                                  //either using the office name if available or using the country name
                                  if(country_phones[value]['office_name']){
                                      formSubtitle.html(callUs[0] + country_phones[value]['office_name'] + callUs[1]);
                                  }else{
                                      formSubtitle.html(countryFallback[0] + value + countryFallback[1]);
                                  }
                              }
                              formPhone.html(country_phones[value]['telephone']);
                              formSubtitle.slideDown();
                              formPhone.slideDown();
                          });
                      } else {
                          resetFormSubtitleAndPhone();
                      }
                  } else {

                      //there are 2 fallbacks available, one for the "default" elements like "None of these" and "UCC Europe Head Office"
                      //the other one for all the other countries that need to fallback to the "Export" data (saved in the theme options)
                      if(value === "" || value === "none" || value === "UCC Europe Head Office"){
                          resetFormSubtitleAndPhone();
                      }else{
                          setToExportSubtitleAndPhone();
                      }
                  }
              });

          function resetFormSubtitleAndPhone(){
              if(formSubtitle.html() !== formSubtitleInitialVal || formPhone.html() !== formPhoneInitialVal){
                  formSubtitle.slideUp();
                  formPhone.slideUp(function () {
                      formSubtitle.html(formSubtitleInitialVal);
                      formPhone.html(formPhoneInitialVal);
                      formSubtitle.slideDown();
                      formPhone.slideDown();
                  });
              }
          }

          function setToExportSubtitleAndPhone(){
              if(formSubtitle.html() !== exportSubtitle || formPhone.html() !== exportPhone){
                  formSubtitle.slideUp();
                  formPhone.slideUp(function () {
                      formSubtitle.html(exportSubtitle);
                      formPhone.html(exportPhone);
                      formSubtitle.slideDown();
                      formPhone.slideDown();
                  });
              }
          }

          //We move the form response at the top of the submit button for usability
          $(".form-response-container").first().insertBefore($("div.frm_submit").first());

          // brands filtering


          /*
           animated line shenanigans
           builds a line, for playing around with later on
           */
          var page_line = $('.page-line');

          function build_page_line() {
              try {
                  var height_reference = $(page_line).parents('.row').find('h2').height();
                  $(page_line).parents("[class*=\"col-\"]").css("height", height_reference + "px");
                  // how tall is our page container and page line container?
                  var container = {top: (height_reference + $(page_line).offset().top), bottom: $('.page-line-stop').offset().top};
                  // console.log(container);
                  // height of container, minus offset of page line element, minus bottom margin
                  var calculated_height = (container.bottom - container.top) - (Math.round(height_reference / 2));
                  $(page_line).css("height", Math.round(calculated_height) + "px");
              } catch (e) {
                  // do nothing
              }
          }

          // we're on a page that needs a line!... exciting times
          build_page_line();

          /*
           funky image squares
           */
          var square_containers = $('.square-box-container');

          function animate_square(square) {
              var horizontalBorder = square.find(".horizontal-line"),
                  verticalBorder = square.find(".vertical-line");
              horizontalBorder.css({"width": "100%"});
              verticalBorder.css({"height": "100%"});
          }


          // animate on scroll
          var scrollPosSquares;

          function animate_on_scroll() {
              scrollPosSquares = $(document).scrollTop();

              $(square_containers).each(function (index, elem) {
                  if ((scrollPosSquares + ($(window).height() / 2)) >= $(this).offset().top) {
                      animate_square($(this).find('.square-box-wrap'));
                  }
              });
          }

          /*
           fixed navigation
           */

          var $navigation_sections = $('[data-label-navigation]'),
              navigation_label = '<li class="nav-label"></li>',
              navigation_label_hidden = '<li class="nav-label hidden"></li>',
              navigation_link = '<a href=""></a>';


          // do we have any navigation sections?
          if ($navigation_sections) {
              // set them up on the page
              $navigation_sections.each(function () {

                  var $this = $(this),
                      content = $this.data('label-navigation'),
                      link = $this.attr('id');

                  if (content !== '') {
                      var nav_label_cloned = $(navigation_label).clone(),
                          nav_link_cloned = $(navigation_link).clone().attr('href', '#' + link).html(content);
                  } else {
                      var nav_label_cloned = $(navigation_label_hidden).clone(),
                          nav_link_cloned = $(navigation_link).clone().attr('href', '#' + link).html(content);
                  }

                  // append our cloned element to the containing element
                  $(nav_label_cloned).data('linked-to', link).appendTo(".fixed-navigation").html(nav_link_cloned);
              });
          }

          $(".fixed-navigation li").append("<span class='hover-helper'></span>");

          /*
           language selections
           */

          // country selector functions
          var picker = $('.country-picker'),
              headerWrap = $(".header-wrap");

          function adjustTopCountryPicker() {
              picker.css({"top": headerWrap.height()});
          }

          adjustTopCountryPicker();
          $(window).resize(function () {
              adjustTopCountryPicker();
          });

          $('.country-select').on('click', '.current a', function (e) {
              e.preventDefault();
              $(this).toggleClass('active');
              picker.toggleClass('active').fadeToggle();
              adjustTopCountryPicker();
              if (picker.hasClass("active")) {
                  $("html, body").css({"overflow": "hidden"});
              } else {
                  $("html, body").attr("style", "");
              }
          });

          // toggle search
          $('.site-search').on('click', 'a', function (e) {
              e.preventDefault();
              $(this).toggleClass('active');
              $(this).closest('.site-search').toggleClass('active');
          });

          // select a language
          $('.language-select').on('click', '.current a', function (event) {

              event.preventDefault();
              event.stopPropagation();

              $(this).toggleClass('active');
              $(this).closest('.header-toggles').toggleClass('active');

              var container = $('.language-select'),
                  $langs = $(container).find('.lang-option'),
                  width = $(container).outerWidth();

              if ($(this).hasClass('active')) {
                  // we're opening up the switcher
                  $($langs.get().reverse()).each(function (index) {
                      $(this).css("transition-delay", (index * 0.25) + "s");
                      $(this).css("right", (width * (index + 1)) + "px");
                      $(this).css("opacity", 1);
                  });
              } else {
                  // close it all down
                  $langs.each(function (index) {
                      $(this).css("transition-delay", "0s");
                      $(this).css("right", "0px");
                      $(this).css("opacity", 0);
                  });
              }

          });

          // fixed navigation scroll event
          function onScroll(event) {
              // var scrollPos = $(document).scrollTop(),
              //     $navigation = $('.fixed-navigation li');
              //
              // $navigation.each(function () {
              //     var currentLink = $(this).find('a'),
              //         refElement = $(currentLink.attr('href'));
              //
              //     if (refElement && refElement.length > 0) {
              //         if (refElement.offset().top <= (scrollPos + 460) && refElement.offset().top + refElement.height() > scrollPos) {
              //             $('fixed-navigation li').removeClass("active");
              //             $(this).addClass("active");
              //         }
              //         else {
              //             $(this).removeClass("active");
              //         }
              //     }
              // });
          }

          onScroll(); //we call it when the page loads as well

          // smooth scroll, mercilessly stolen from a JSFiddle
          $('.fixed-navigation a[href^="#"]').on('click', function (e) {
              e.preventDefault();
              $(document).off("scroll", onScroll);

              // $('a').each(function () {
              //     $(this).removeClass('active');
              // });
              // $(this).addClass('active');

              var target = this.hash,
                  $target = $(target);

              $('html, body').stop().animate({
                  'scrollTop': $target.offset().top - parseInt($target.css("margin-top")) - $("header.header-wrap").outerHeight()
              }, 500, 'linear', function () {
                  // window.location.hash = target;

                  // set up our scroll events again

                  $(document).on("scroll", onScroll);
              });
          });

          //addition for more general scrolling
          $(".scroll-to-target").click(function (e) {
              e.preventDefault();

              var targetSelector = $(this).attr("href");

              if (targetSelector && $(targetSelector).length > 0) {
                  var element = $(targetSelector),
                      elementMarginTop = (element.outerHeight(true) - element.height()) / 2;
                  $('html, body').animate({
                      scrollTop: $(targetSelector).offset().top - ($("header.primary").outerHeight() + elementMarginTop + 5)
                  }, 850);
              }
          });


          // sticky header
          function headerResize() {
              var scrollPos = $(window).scrollTop(),
                  screenWidth = $(window).width(),
                  header = $('.header-wrap');

              if (scrollPos >= 150 && screenWidth > 768) {
                  $(header).addClass('active');
                  $('body').addClass('scroll-active');
              } else {
                  $(header).removeClass('active');
                  $('body').removeClass('scroll-active');
              }

          }


          // adjust top margin and height of our 'discover more' blocks
          function adjust_discover_more() {

              // need to check screen width, this shouldn't trigger on mobile
              // check scren width here, yay it's big enough
              var $parent = $('.discover-more'),
                  title_height = $parent.find('.heading').outerHeight(true),
                  intro_height = $parent.find('.intro').outerHeight(true),
                  offset = intro_height - title_height,
                  $blocks = $parent.find('.block > div'),
                  quote = $parent.find('.quote');

              if ($parent.length > 0) {
                  // we need our window width
                  var windowWidth = $(window).width(),
                      block_one_height = $($blocks[0]).outerHeight(),
                      block_two_height = block_one_height + offset;

                  // Get the height of the quote box
                  var quote_height = $(quote)[0].getBoundingClientRect().height;

                  if (windowWidth >= 992) {
                      css = {"height": block_two_height + "px", "margin-top": "-" + offset + "px"};
                      quote_css = {"margin-top": "-" + quote_height + "px"};
                  } else {
                      css = {"height": "initial", "margin-top": "0"};
                      quote_css = {"margin-top": "0px"};
                  }

                  $($blocks[1]).css(css);
                  $(quote).css(quote_css);
              }
          }

          // adjust discover more section
          setTimeout(function () {
              adjust_discover_more();
          }, 1);
          $(window).on("load", function () {
              setTimeout(function () {
                  adjust_discover_more()
              }, 1);
          });

          // network locations interactive map
          $('.network-locations').on('click', '.location', function (event) {
              event.stopPropagation();
              $locations = $('.network-locations').find('.location');
              $locations.removeClass('active');
              $(this).addClass('active');
          });


          $('.network-locations').on('click', '.region', function () {
              $locations = $(this).find('.location');
              $locations.removeClass('active');
          });

          $('.results').on('click', '.blog-load-more a', function (e) {
              e.preventDefault();

              var element = $(this);
              var loading = $(this).siblings('div');
              var target = $(this).attr('href');
              var container = $('.posts-load');

              $(element).hide();
              $(loading).show();

              $.ajax({
                  url: target,
                  type: 'GET',
                  success: function (data) {
                      var contents = $(data).find('.posts-load').html();

                      // hide our button
                      $(loading).parents('.post-wrapper').remove();
                      $(loading).hide();

                      $(contents).appendTo(container).hide().slideDown(400, 'swing', function () {
                          $('[data-mh]').matchHeight({remove: true});
                          $('[data-mh]').matchHeight();
                      });

                      // update address bar
                      // history.pushState(contents, title, target);
                  }
              });
          });

          // pop this here, it'll get used in a minute..
          function add_languages_or_location(e, index, target, height) {
              var element = '<li data-top="-' + height * (index + 1) + '" style="margin-top: -50px; opacity: 0;"><a href="#"><img src="" /><span class="native-name"></span></a></li>',
                  nativename = $(e).find('.native-name').text(),
                  image = $(e).find('img').attr('src'),
                  href = $(e).find('a').attr('href');

              //if we are looking for a country, the nativename will more likely be empty, let's look for the country-name
              if (!nativename) {
                  nativename = $(e).find(".country-name").text();
              }

              var _this = $(element).clone().appendTo(target);

              $(_this).find('a').attr('href', href);
              $(_this).find('img').attr('src', image);
              $(_this).find('.native-name').html(nativename);
          }

          // populates language selection on mobile menus, activated when main mobile menu toggled
          function populate_mobile_menus(e) {
              // ok, we need to populate this thing
              // let's grab everything we'll need
              e.each(function (index, e) {
                  var newhome = $(e).siblings('ul'),
                      content = $($(e).data('target')),
                      content_strip = content.not('.current'),
                      height = 40;

                  // ok, we're not active - let's check to see if this is the first time we've clicked it
                  if ($.trim(newhome.html()) === '') {

                      $(content_strip).each(function (index) {
                          add_languages_or_location($(this), index, newhome, height);
                      });
                  }
              });
          }

          // populate language / location menus in mobile nav on toggle, if not already populated
          $('.mobile-menu-toggle').click(function () {

              var $navelements = $(this).siblings('ul').find('li');

              $(this).toggleClass('active');

              if ($(this).hasClass('active')) {
                  // we're opening up the switcher
                  $navelements.each(function (index) {
                      $(this).css("transition-delay", (index * 0.175) + "s");
                      $(this).css("margin-top", "0px");
                      $(this).css("opacity", 1);
                  });
              } else {
                  // close it all down
                  $($navelements.get().reverse()).each(function (index) {
                      $(this).css("transition-delay", "0s");
                      $(this).css("margin-top", "-50px");
                      $(this).css("opacity", 0);
                  });
              }

          });

          // submenu dropdown
          $(".menu-item-has-children").hover(function () {
              if (!$(".mobile-nav-toggle-wrap").is(":visible")) {
                  $(this).children(".sub-menu").stop().slideDown();
              }
          }, function () {
              var $this = $(this);
              $this.children(".sub-menu").stop().slideUp(function(){
                  $this.children(".sub-menu").attr("style","")
              });
          });

          // highlight parent menu item if sub item is active
          $(".current-menu-item").each(function(index, elem){
              if($(elem).parent().closest(".menu-item").length > 0){
                  var parentMenuItem = $(elem).parent().closest(".menu-item");
                  parentMenuItem.addClass("current-menu-item");
                  parentMenuItem.parent().closest(".menu-item").addClass("current-menu-item");
              }
          });


          // menu toggle class toggle
          $('#main-menu').on('show.bs.collapse', function () {
              $("html,body").addClass("no-scroll");
              $(".dropdown-toggle").addClass("active");
              populate_mobile_menus($('.mobile-menu-toggle'));
          });

          $('#main-menu').on('hide.bs.collapse', function () {
              $("html,body").removeClass("no-scroll");
              $(".dropdown-toggle").removeClass("active");
          });

          $(document).on("scroll", function(){
              onScroll();
              headerResize();
              animate_on_scroll();
          });

          $(window).on("resize", function () {
              adjust_discover_more();
          });

          $('.country-list-wrapper li .wrapper').click(function (e) {
              $('html, body').animate({
                  scrollTop: $(".frm_fields_container").offset().top
              }, 1000);
          });


          /*=========================================*/
          /*===  SCROLL MAGIC BREADCRUMB LISTENER ===*/
          /*=========================================*/
          $(".white-breadcrumbs-on-this-bg").each(function (index, elem) {
              var $elem = $(elem);
              UTIL.assignBreadcrumbColorScene($elem);
          });



          /***** Ajax for Forms *****/
          $('#form_contact-form, #form_contact-form2, #form_contact-form3, #form_contact-form4, #form_contact-form5, #form_contact-form6').submit(function (e) {
              e.preventDefault();
              e.stopPropagation();

              var data = $(this).serialize(),
                  $this = $(this),
                  country = $this.find(".input-country").val(),
                  sendTo = "";

              //manually adding the fields to be sure
              if ($this.find(".input-country").length > 0 && $this.find(".input-country").val()) {
                  data += ("&dropdown=" + $this.find(".input-country").val());
              }
              if ($this.find(".input-fullname").length > 0 && $this.find(".input-fullname").val()) {
                  data += ("&fullname=" + $this.find(".input-fullname").val());
              }
              if ($this.find(".input-email").length > 0 && $this.find(".input-email").val()) {
                  data += ("&email=" + $this.find(".input-email").val());
              }
              if ($this.find(".input-phone").length > 0 && $this.find(".input-phone").val()) {
                  data += ("&phone=" + $this.find(".input-phone").val());
              }
              if ($this.find(".input-message").length > 0 && $this.find(".input-message").val()) {
                  data += ("&message=" + $this.find(".input-message").val());
              }

              if (country_phones && country && country_phones.hasOwnProperty(country)) {
                  if (country_phones[country]['email']) {
                      sendTo = country_phones[country]['email'];
                  }
              }

              if ($this.find(".input-country").length > 0 && !$this.find(".input-country").val() ||
                  $this.find(".full-name input").length > 0 && !$this.find(".full-name input").val() ||
                  $this.find(".email input") && !$this.find(".email input").val() ||
                  $this.find(".telephone input") && !$this.find(".telephone input").val() ||
                  $this.find(".message_input textarea") && !$this.find(".message_input textarea").val()) {
                  $(".form-response-container").slideUp(function () {
                      $(".form-response-container").html("<p style=\"margin-bottom:0;\" class='alert alert-warning'>Please fill in all the fields.</p>");
                      $(".form-response-container").slideDown();
                  });
              } else {
                  $(".frm_button_submit").append("<i class='fa fa-spinner fa-spin' style='margin-left: 3px'></i>");
                  $.ajax({
                      url: ajax_object['ajax_url'],
                      type: "POST",
                      data: {"data": data, "sendTo": sendTo, "action": "send_country_email"},
                      success: function (response) {
                          $(".form-response-container").siblings().slideUp();
                          $(".form-response-container").slideUp(function () {
                              $(".form-response-container").html("<p style=\"margin-bottom:0;\" class='alert alert-success'>Your message has been sent successfully!</p>");
                              $(".form-response-container").slideDown();
                          });
                      },
                      error: function (data) {
                          $(".form-response-container").slideUp(function () {
                              $(".form-response-container").html("<p style=\"margin-bottom:0;\" class='alert alert-warning'>It has not been possible to process your message. Please try again later.</p>");
                              $(".form-response-container").slideDown();
                          });
                      },
                      always: function () {
                          $(".frm_button_submit .fa-spinner").remove();
                      }

                  });
              }
          });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

          $(window).load(function(){
             setTimeout(function () {
                 var $navigation_sections = $('[data-label-navigation]'),
                     breadcrumbsController = new ScrollMagic.Controller();
                 if ($navigation_sections) {

                     var $nav_sections_length = $navigation_sections.length;
                     //we link the scroll scene to the anchors created
                     $navigation_sections.each(function (index, elem) {

                         var $elem = $(elem),
                             duration = $elem.outerHeight(true),
                             offset = -parseInt($elem.css("marginTop"));

                         if ($elem.data("scrollMagicNoMargin") == true) {
                             offset = 0;
                         }

                         if ($elem.data("offset")) {
                             offset += parseInt($elem.data("offset"));

                         }

                         if ($elem.data("additionalSection")) {
                             var additionalSections = $($elem.data("additionalSection"));
                             additionalSections.each(function (index, elem) {
                                 duration += $(elem).height();
                             });
                         }

                         //we identify the link that needs to be toggled when we enter this section
                         var navigationLinks = $(".fixed-navigation li"),
                             associatedLink = navigationLinks.filter(function (index, element) {
                                 return $(element).data("linkedTo") && $(element).data("linkedTo") === $elem.attr("id");
                             });

                         //we add for each navigation section a scene that will trigger its associated link
                         var sectionScene = new ScrollMagic.Scene({
                             triggerElement: $elem.get(0),
                             duration: calculateDuration($elem),
                             offset: offset
                         })
                             .setClassToggle(associatedLink.get(0), "active")
                             .addTo(breadcrumbsController);

                         if(index == 0){
                             var firstSectionScene = new ScrollMagic.Scene({
                                 triggerElement: $("body").get(0),
                                 triggerHook : 0,
                                 duration: 25,
                                 offset: 0
                             })
                                 .setClassToggle(associatedLink.closest(".fixed-navigation").get(0), "forced-first-navigation")
                                 .addTo(breadcrumbsController);
                         }


                         if(index == ($nav_sections_length - 1)){
                             var lastSectionScene = new ScrollMagic.Scene({
                                 triggerElement: $("body").get(0),
                                 triggerHook : 1,
                                 duration: 250,
                                 offset: $("body").height() - 20
                             })
                                 .setClassToggle(associatedLink.closest(".fixed-navigation").get(0), "forced-last-navigation")
                                 .addTo(breadcrumbsController);
                         }


                         $(window).on("resize", function () {
                             var newDuration = calculateDuration($elem);
                             sectionScene.duration(newDuration);
                         });

                         function calculateDuration($elem) {
                             var duration = $elem.outerHeight(true);
                             if ($elem.data("scrollMagicNoMargin") == true) {
                                 duration = $elem.outerHeight();
                             }

                             if ($elem.data("additionalSection")) {
                                 var additionalSections = $($elem.data("additionalSection"));
                                 additionalSections.each(function (index, elem) {
                                     duration += $(elem).height();
                                 });
                             }

                             if ($elem.data("duration")) {
                                 duration = (duration * parseFloat($elem.data("duration")));
                             }

                             if ($elem.data("durationAdd")) {
                                 duration += parseFloat($elem.data("durationAdd"));
                             }

                             return duration;
                         }
                     });
                 }


                 //ADDITIONAL SCROLL LISTENER FOR CAROUSEL ON THE HOMEPAGE
                 var networkLocationCarouselHeight = $(".network-locations-carousel").height();
                 $(window).resize(function(){
                     networkLocationCarouselHeight = $(".network-locations-carousel").height();
                 });

                 if ($(".network-locations-carousel").length > 0) {
                     var hideOnCarouselHomepage = new ScrollMagic.Scene({
                         triggerElement: $(".network-locations-carousel").get(0),
                         triggerHook: 0.5,
                         duration: networkLocationCarouselHeight,
                         offset: 0
                     })
                         .setClassToggle($(".fixed-navigation").get(0), "hide-momentarily")
                         .addTo(breadcrumbsController);
                 }

                 $('.network-locations-carousel .cover-anchor').on('click', function (event) {
                     event.stopPropagation();
                 });

                 //ADDITIONAL SCROLL LISTENER FOR ALL THE DELIVER MORE BLOCK
                 var discoverMoreSection = $(".discover-more").height();
                 $(window).resize(function(){
                     discoverMoreSection = $(".discover-more").height();
                 });

                 if ($(".discover-more").length > 0) {
                     var hideOnCarouselHomepage = new ScrollMagic.Scene({
                         triggerElement: $(".discover-more").get(0),
                         triggerHook: 0.5,
                         duration: discoverMoreSection,
                         offset: 0
                     })
                         .on('enter', function (event) {
                             if($(".fixed-navigation").outerWidth() > $(".discover-more").first().find("h3").first().offset().left){
                                 $(".fixed-navigation").addClass("hide-momentarily");
                             }
                         })
                         .on('leave', function (event) {
                             $(".fixed-navigation").removeClass("hide-momentarily");
                         })
                         .addTo(breadcrumbsController);
                 }

             },20);
          });
      }
    },
    // template-home.php related JS
    'page_template_template_home': {
      init: function() {
        // JavaScript to be fired on the home page

        // re-written (for the 4th time), carousel functionality...
        // carousel object-y thing
        var carousels = {};

        // grab our network carousels
        approach_carousels = $('[class*="approach-carousel-"]');
        network_carousels = $('[class*="network-locations-"]');

        function sync_carousels(element) {
          var target = $(element).data('linked');
        }

        /* NETWORK CAROUSELS */
        $(network_carousels).each(function() {
            var $this = $(this),
                carousel_id = $this.data('carousel-id');

            //we prepare the elements before the owlSliders are declared so that they bring with them the index
            //we want to move to when we click on the owl item (this avoid cloning index issues)
            $this.children().each(function (index, elem) {
                $(elem).attr('data-position', index);
            });

            carousels[carousel_id] = $this.owlCarousel({
                items: 1,
                loop: true,
                dots: false,
                center: true,
                onChanged: function (event) {
                    var target = $(this).data('linked');
                    $(carousels[target]).trigger('to.owl.carousel', event.item.index);
                },
                onInitialized: function (event) {
                    //we assign a click listener to the elements to that we move to the desired one using the data position previously assigned
                    var owlElement = $(event.currentTarget);
                    owlElement.on("click", ".owl-item", function (e) {
                        owlElement.trigger("to.owl.carousel", $(this).children(".network-slide").data("position"));
                    });

                    owlElement.find(".network-content").matchHeight();

                    UTIL.assignBreadcrumbColorScene($this);
                },
                responsive: {
                    0 : {
                        items: 1,
                        stagePadding: 50
                    },
                    768: {
                        items: 3
                    },
                    1200: {
                        items: 5,
                        startPosition: 2,
                        stagePadding: 50
                    }
                }
            });
        });

        /* APPROACH CAROUSELS */

        var app_main_carousel_id = $('.approach-carousel-main').data('carousel-id');

        function customPager(event) {
          // console.log($(this));
          // console.log($(this).find('.owl-item'));
          // console.log(event);
        }

        // onInitialize
        $('.approach-carousel-main').on('initialize.owl.carousel', function() {
          // fake bullets!
          var items = $(this).find('.item'),
              fakeBullets = $('.slideshow-bullets-wrapper .slideshow-bullets'),
              realBullets = $('.approach-nav.slideshow-bullets div'),
              bullet = '<div></div>';

          $(items).each(function(index) {
            var _this = $(bullet).clone();
            $(_this).appendTo(fakeBullets);
          });

        });

        $(".approach-carousel-main").on("initialized.owl.carousel", function(){
            UTIL.assignBreadcrumbColorScene($(".approach-carousel-main"));
        });

        carousels[app_main_carousel_id] = $('.approach-carousel-main').owlCarousel({
          items: 1,
          loop: false,
          dotsContainer: '.approach-nav.slideshow-bullets [class*="col-"]',
          dotsData: true,
          // onInitialized: customPager,
          // onRefreshed: customPager,
          // onChange: function(event) {


          //   var current_index = event.item.index,
          //       length = (event.item.count ? event.item.count - 1 : 0 );

          //   console.log(event.property.name);
          //   console.log(event.property.value);

          //   console.log(current_index + ' - ' + length);

          //   console.log(event);
          // },
          onChanged: function(event) {
            // event.item.index
            // we need to set up a second set of navigation dots, owl carousel doesn't seem to
            // support this out of the box, so we fake it
            var fakeDots = '.slideshow-bullets-wrapper .slideshow-bullets div';
            $(fakeDots).removeClass('active');
            $(fakeDots).eq(event.item.index).addClass('active');



            var current_index = event.item.index,
                length = (event.item.count ? event.item.count - 1 : 0 );

            var nav_all = $('.slide-nav'),
                nav_prev = $('.slide-nav.prev'),
                nav_next = $('.slide-nav.next');

            // console.log(event);

            // console.log(current_index + ' - ' + length);
            // console.log(event);

            $(nav_all).removeClass('inactive');

            if(current_index === 0) {
              // we're at the start, so 'nav_prev' should be greyed out
              // console.log('at start');
              $(nav_prev).addClass('inactive');
            }

            if(current_index === length) {
              // we're at the end, so 'nav_next' should be greyed out
              // console.log('at end');
              $(nav_next).addClass('inactive');
            }

            // if(current_index > 0 && current_index < length) {
            //   $(nav_prev).removeClass('inactive');
            //   $(nav_next).removeClass('inactive');
            // }

          }
        });

        // no longer being used
        // var app_nav_carousel_id = $('.approach-carousel-nav').data('carousel-id');

        // carousels[app_nav_carousel_id] = $('.approach-carousel-nav').owlCarousel({
        //   items: 6,
        //   loop: false,
        //   center: false,
        // });

        // next or prev?
        function carousel_direction(element) {
          if(element.hasClass('next')) {
            return 'next';
          }
          if(element.hasClass('prev')) {
            return 'prev';
          }
        }

        // fake dots
        // on click, send carousel to relevant slide
        $('.approach-nav.slideshow-bullets').on('click', '.dot', function() {
          $(carousels['approach-slideshow-main']).trigger('to.owl.carousel', $(this).parent().index());
        });

        // prev / next buttons
        $('.slide-nav').click(function() {

          var target = $(this).data('carouselTarget'),
              action = carousel_direction($(this));

          switch(action) {
            case 'next':
              // console.log('next next next, woop');
              carousels[target].trigger('next.owl.carousel');
              // console.log(carousels[target].currentItem);
              break;
            case 'prev':
              // console.log('prev prev prev, woop');
              carousels[target].trigger('prev.owl.carousel');
              // console.log(carousels[target].currentItem);
              break;
          }

        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page


        // $(network_carousels).each(function() {
        //   $(this).on('changed.owl.carousel', function(event) {
        //     // console.log($(this).data('linked'));
        //     // console.log(event);
        //     var linked_to = $(this).data('linked');

        //     // event.item.index;
        //     // network_carousels[linked_to].trigger("to.owl.carousel", [event.item.index, 250, true]);

        //   });
        // });


        // slideshows!
        // $('.owl-carousel').owlCarousel({
        //   loop: true,
        //   items: 1,
        //   dotsContainer: '.slideshow-bullets'
        // });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
      // Home page
      'blog': {
          init: function () {
              $.fn.matchHeight._maintainScroll = true;
          },
          finalize: function () {
              // JavaScript to be fired on the home page, after the init JS
          }
      },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
      scrollingController : new ScrollMagic.Controller(),
      assignBreadcrumbColorScene: function(elem) {
        var scene = new ScrollMagic.Scene({
            triggerElement: elem.get(0),
            duration: elem.outerHeight()
        })
            .setClassToggle($(".fixed-navigation").get(0), "on-dark-background")
            .addTo(UTIL.scrollingController);
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
